import styled from "styled-components";

// Re-exports the shared confirm surface; only Eyebrow is discard-specific.
export * from "../confirmShared/styles";

export const Eyebrow = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
`;
